import { render, staticRenderFns } from "./vehcileTag.vue?vue&type=template&id=60e09b9d&"
import script from "./vehcileTag.vue?vue&type=script&lang=js&"
export * from "./vehcileTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports